import React from 'react'
import { Box, Text, useResponsiveWrapperContext } from '@usap/uicomponents'
import Image from './image'

export default function ItemView({
  data,
  colWidth,
  index,
  onBlogClick,
  isBot,
}) {
  const { isDesktop } = useResponsiveWrapperContext()

  return (
    <Box
      key={data.title}
      width={colWidth}
      pad="medium"
      border={
          index === 0
            ? { size: '0px' }
            : { size: 'xsmall', color: 'light-3', side: 'left' }
        }
    >
      <Box
        width={isDesktop ? '377px' : '320px'}
        height={isDesktop ? '200px' : 'auto'}
        pad={{ bottom: 'small' }}
        alignSelf="center"
      >
        <a
          href={data.link}
          target="_blank"
          rel="noopener noreferrer"
          onClick={onBlogClick}
          aria-label={data.title}
        >
          <Image
            fit="cover"
            layout="fixed"
            height="100%"
            width="100%"
            isBot={isBot}
            alt={data.title}
            src={data.imageSrc}
          />
        </a>
      </Box>

      <Box>
        <a
          href={data.link}
          target="_blank"
          rel="noopener noreferrer"
          onClick={onBlogClick}
        >
          <Text
            size="small"
            weight={700}
            color="dark-2"
            dangerouslySetInnerHTML={{
              __html: data.title,
            }}
          />
        </a>

        <Text
          color="dark-2"
          size="small"
          className="blog-text"
          style={{ padding: 0 }}
          dangerouslySetInnerHTML={{
            __html: data.content,
          }}
        />
      </Box>
    </Box>
  )
}
